import axios from 'axios'
import { cookieUtils } from '@/utils/cookies'


const apiClient = axios.create({
  baseURL: import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 10000
})

apiClient.interceptors.request.use(
  (config) => {
    const token = cookieUtils.getJWTToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  },
)

const authApiClient = axios.create({
  baseURL: (import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337') + '/api',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 10000,
})

// Add request interceptor to include JWT token
authApiClient.interceptors.request.use(
  (config) => {
    const token = cookieUtils.getJWTToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

authApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error)
  },
)

export default apiClient
export { authApiClient }
